import React from "react";
import $ from 'jquery';

const CartTimer = () => {
        return (
            <div><div id="revese-timer" data-minute="1"/></div>
    );
};

export default CartTimer;